import {
  Avatar,
  Box,
  Button,
  Divider,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Typography,
} from "@mui/material";
import { useAuth } from "../../context/GlobalState";
import React from "react";
import StarIcon from "@mui/icons-material/Star";

export default function CheckoutProduct() {
  const { basket, dispatch } = useAuth();

  return (
    <Box>
      {basket.map((item) => (
        <List
          key={item}
          sx={{
            width: { md: "80%", sx: "100%", lg: "70%" },
            maxWidth: "100%",
            bgcolor: "background.paper",
          }}
        >
          <ListItem
            sx={{
              display: "flex",
              alignItems: { sm: "flex-start", xs: "center" },
              justifyContent: { sm: "flex-start", xs: "center" },
              textAlign: { sm: "start", xs: "center" },
              flexDirection: { xs: "column", sm: "row" },
            }}
          >
            <ListItemAvatar>
              <Avatar
                alt="Remy Sharp"
                src={item.img}
                sx={{ width: "100%", height: "200px", borderRadius: "0" }}
              />
            </ListItemAvatar>

            <ListItemText
              sx={{
                ".MuiTypography-body1": {
                  fontWeight: 800,
                  fontSize: "18px",
                  textAlign: { sm: "left", sx: "center" },
                },
              }}
              primary={item.title}
              secondary={
                <React.Fragment>
                  <Typography
                    component="p"
                    variant="body1"
                    ml={{ sm: 4, xs: 0 }}
                    mt={3}
                    sx={{ color: "text.primary", fontWeight: 600 }}
                  >
                    {item.price}$
                  </Typography>

                  <Typography
                    sx={{
                      display: "flex",
                      ml: { sm: 2, xs: 0 },
                      justifyContent: { sm: "left", xs: "center" },
                    }}
                  >
                    {Array(item.rate)
                      .fill()
                      .map((i) => (
                        <Box key={i}>
                          <StarIcon color="warning" />
                        </Box>
                      ))}
                  </Typography>

                  <Button
                    variant="contained"
                    sx={{
                      bgcolor: "#fcd115",
                      color: "#111",
                      ml: { sm: 3 },
                      width: { xs: "100%", sm: "60%" },
                      py: 1.2,
                    }}
                    onClick={() => {
                      dispatch({
                        type: "REMOVE_FROM_BASKET",
                        id: item.id,
                      });
                    }}
                  >
                    Remove From Basket
                  </Button>
                </React.Fragment>
              }
            />
          </ListItem>
          <Divider
            variant="inset"
            component="li"
            sx={{ bgcolor: "#999", width: { xs: "100%" }, m: { xs: 0 } }}
          />
        </List>
      ))}
    </Box>
  );
}
